/**
 * Dependencies for Remote Components
 */

module.exports = {
	resolve: {
		axios: require('axios'),
		classnames: require('classnames'),
		mathjs: require('mathjs'),
		numbro: require('numbro'),
		'prop-types': require('prop-types'),
		react: require('react'),
		'react-device-detect': require('react-device-detect'),
		'react-redux': require('react-redux'),
		'react-svg': require('react-svg'),
		redux: require('redux'),
		'redux-form': require('redux-form'),
		validator: require('validator'),
		'@ant-design/icons': require('@ant-design/icons'),
		'react-event-listener': require('react-event-listener'),
		'hollaex-web-lib': require('hollaex-web-lib'),
		antd: require('antd'),
		moment: require('moment'),
	},
};
